<main>
  <section
    style="
      background-image: url('assets/images/home-hero-bg.jpg');
      background-size: cover;
    "
  >
    <div class="container py-5">
      <div class="row align-items-start g-lg-5 py-5 login-row">
        <div class="col-md-10 mx-auto col-lg-5 d-none d-lg-block">
          <ins-login></ins-login>
        </div>
        <div class="col-lg-7 text-lg-start text-light p-4 p-md-5">
          <h1 class="display-4 lh-1 mb-4">Fair and reliable coverage.</h1>
          <p class="col-lg-10 fs-5">
            We're proud to offer the ag industry the insurance solutions,
            personal claim service and relationship-driven experience you
            expect.
          </p>
        </div>
      </div>
    </div>
  </section>

  <div class="container px-5 py-lg-5 mt-lg-5" id="featuredTasks">
    <div class="row g-4 py-5 row-cols-1 row-cols-md-3">
      <div class="feature col border-end">
        <div class="feature-icon">
          <img
            width="96"
            height="86"
            src="assets/images/quote-icon.svg"
            alt="Get a Quote"
          />
        </div>
        <h4 class="text-primary my-4">Get a Quote</h4>
        <p class="mb-5">
          Let us know about you and your operation so we can determine your
          coverage requirements.
        </p>
        <a routerLink="/get-quote" class="btn btn-outline-primary mb-auto">
          Get Started
        </a>
      </div>
      <hr class="d-md-none" />
      <div class="feature col border-end ps-md-5">
        <div class="feature-icon">
          <img
            width="77"
            height="86"
            src="assets/images/file-claim-icon.svg"
            alt="File a Claim"
          />
        </div>
        <h4 class="text-primary my-4">File a Claim</h4>
        <p class="mb-5">
          Report a claim anytime, and our staff will respond quickly with
          helpful information and support.
        </p>
        <a
          href="javascript:void(0)"
          (click)="downloadClaimPacket()"
          class="btn btn-outline-primary"
        >
          Begin Claim
        </a>
      </div>
      <hr class="d-md-none" />
      <div class="feature col ps-md-5">
        <div class="feature-icon">
          <img
            width="89"
            height="86"
            src="assets/images/login-icon.svg"
            alt="Agent Login"
          />
        </div>
        <h4 class="text-primary my-4">Agent Login</h4>
        <p class="mb-5">
          Use our portal to access the tools and resources needed to assist and
          support your customers.
        </p>
        <a routerLink="/login" class="btn btn-outline-primary">Login</a>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="d-md-flex flex-md-equal w-100 my-md-5">
      <div class="overflow-hidden d-flex justify-content-end">
        <img
          class="h-100"
          src="assets/images/home-about-relationship.jpg"
          alt="Men in field talking about farming in front of an irrigation pivot."
        />
      </div>
      <div class="pt-3 pt-md-5 overflow-hidden bg-secondary">
        <div class="my-3 p-3 ps-5">
          <h2 class="display-5 mb-4">Relationship-driven</h2>
          <p class="lead mb-5">
            The "personal touch" has always set us apart and helped grow us into
            the ag industry's largest insurer of irrigation systems. We know our
            customers and how important it is that their operation stays up and
            running.
          </p>
          <a class="btn btn-primary" routerLink="/about">
            Learn More about DFS
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="d-md-flex flex-md-equal w-100 my-md-5 align-items-center">
      <div class="pt-3 pt-md-5 overflow-hidden">
        <div class="my-3 py-3 px-5">
          <p class="fs-3">
            "DFS Insurance has been a great partner for our operation over the
            last 10 years. Their speedy claims process has allowed our farm to
            stay up and running with minimal downtime."
          </p>
          <p class="fw-semibold">
            Bart Davis
            <br />
            <small class="fw-normal">Doerun, GA</small>
          </p>
        </div>
      </div>
      <div class="overflow-hidden d-flex justify-content-start">
        <img class="h-100" src="assets/images/BartDavis.jpg" alt="Bart Davis" />
      </div>
    </div>
  </div>
</main>
